import { useEffect } from 'react';
import './TermsAndConditions.css';
import Footer from "../Footer";
import Head from '../Head';
const TermsAndConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <div className="top-head-section-new"></div>
      <div className="faq-section term-condition-page">
        <div className="container">
          <div className="aboutUs-header">
            <Head /></div>
          <h2 class="aboutUs-heading main-container-section term-condition-heading">Terms & Conditions</h2>
          <div className="about-us">

            <ol className="order-list">
              <li><h4>Acceptance of Terms</h4>
                <p>By accessing and using LF Coin ($LAL) and related services, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our services.</p></li>

              <li><h4 className="mb-2"> Nature of LF Coin ($LAL)</h4>
                <ul>
                  <li>$LAL is a meme coin with no intrinsic value and does not represent ownership, investment, or security.</li>
                  <li>It is not affiliated with the Los Angeles Lakers, the NBA, or any other sports organizations.</li>
                  <li>The token is designed for community engagement and entertainment purposes only</li>
                </ul></li><br />
              <li><h4 className="mb-2">Community & NFT Membership</h4>
                <ul>
                  <li>NFT holders may gain access to exclusive giveaways, voting rights, and special events.</li>
                  <li>Eligibility for giveaways is subject to compliance with the stated requirements.</li>
                </ul></li><br />

              <li><h4 className="mb-2"> No Financial Advice</h4>
                <ul>
                  <li>$LAL does not guarantee profits or returns.</li>
                  <li>Users acknowledge that cryptocurrency investments are volatile and should conduct their own research.</li>
                </ul></li><br />

              <li><h4 className="mb-2"> Use of Website & Community</h4>
                <ul>
                  <li>Users must respect community guidelines and refrain from spam, fraud, or misleading activities.</li>
                  <li>We reserve the right to ban users who violate community rules</li>
                </ul></li><br />


              <li><h4 className="mb-2">Legal Compliance</h4>
                <ul>
                  <li>Users are responsible for ensuring their participation in crypto transactions complies with local laws.</li>
                  <li>The project operates under Wyoming LLC jurisdiction.</li>
                </ul></li><br />

              <li><h4 className="mb-2">Changes & Termination</h4>
                <ul>
                  <li>LF Coin reserves the right to update these Terms at any time..</li>
                  <li>Continued use of the website and services constitutes acceptance of any updates.</li>
                </ul></li><br />
              <li><h4 className="mb-2">Contact Information</h4>
                <ul>
                  <li>For inquiries, reach us at  <a href="mailto:support@lfcoin.io" className="support-link">
                    support@lfcoin.io
                  </a></li>

                </ul></li><br />

            </ol>

          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 disclouser-sec">
              <div className="lend-cont-inner-in">
                <p>
                  <strong>Disclosure: </strong>
                  LF Coin ($LAL) is a community-driven meme coin created to
                  celebrate sports fandom and foster community engagement.
                  LF Coin is not affiliated with the Los Angeles Lakers, the
                  National Basketball Association (NBA), or any associated
                  organizations. The project operates independently and is
                  solely focused on building a decentralized community of
                  sports enthusiasts. As a meme coin, LF Coin carries no
                  intrinsic value and should not be considered an investment
                  or security.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className="about-footer">
        <Footer /></div>
    </>
  );
};

export default TermsAndConditions;